<template>
  <section class="layout-section">
    <article v-scroll:reveal="{ delay: 200 }" class="publication-single__body">
      <div v-scroll:reveal="{ delay: 250 }" class="rte" v-html="cleanedContent" />
    </article>
  </section>
</template>

<script>
import { formatContent } from '@/helpers/content-formatting'

export default {
  name: 'ResourcesMonitoringSingleContent',
  props: {
    publication: {
      type: Object,
      deault: null
    }
  },
  computed: {
    cleanedContent() {
      if (!this.publication.content) return ''
      return formatContent(this.publication.content)
    }
  }
}
</script>
